import debounce from 'lodash/debounce';
export default {
  data() {
    return {
      valid: {
        minimum_amount: [true],
        expiration_days: [true],
        valid_days_before: [true],
        title: [false],
        description: [false],
      },
      success: {
        minimum_amount: [true],
        expiration_days: [true],
        valid_days_before: [true],
        title: [false],
        description: [false],
      },
      error: {
        minimum_amount: [''],
        expiration_days: [''],
        valid_days_before: [''],
        title: [''],
        description: [''],
      },
      errorMessages: {
        minimumAmountRequired: {
          el: 'Προσθέστε το ελάχιστο ποσό για αυτό το πακέτο',
          en: 'Please add the minimum amount for this package.',
          it: "Si prega di aggiungere l'importo minimo  per questo pacchetto.",
        },
        minimumAmountGreaterThan100: {
          el: 'Αυτός ο αριθμός δεν μπορεί να είναι μικρότερος του 100',
          en: 'This number cannot be less than 100',
          it: 'Questo numero non può essere inferiore a 100',
        },
        minimumAmountExceededFrom: {
          el: 'Ο ελάχιστος αριθμός πρέπει να είναι μεγαλύτερος από',
          en: 'This number must be greater than',
          it: 'Questo numero non può essere inferiore al numero minimo del livello precedente',
        },
        minimumAmountExceededTo: {
          el: 'Ο αριθμός αυτός πρέπει να είναι μικρότερος από',
          en: 'This number must be less than',
          it: 'Questo numero deve essere inferiore al',
        },
        maximumAmountRequired: {
          el: 'Προσθέστε το μέγιστο αριθμό πόντων για αυτό το πακέτο.',
          en: 'Please add the maximum amount of points for this package.',
          it: "Si prega di aggiungere l'importo massimo di punti per questo pacchetto",
        },
        maximumAmountExceededFrom: {
          el: 'Ο μέγιστος αριθμός πρέπει να είναι μεγαλύτερος από τον ελάχιστο αριθμό αριθμό πόντων της βαθμίδας του',
          en: "This number must be greater than the tier's minimum number of points",
          it: 'Questo numero deve essere superiore al numero minimo di punti previsto dal livello',
        },
        maximumAmountExceededTo: {
          el: 'Ο μέγιστος αριθμός πρέπει να είναι μικρότερος από τον μέγιστο αριθμό της επόμενης βαθμίδας',
          en: 'This number cannot exceed the maximum number of the next tier',
          it: 'Questo numero non può superare il numero massimo del livello successivo',
        },
        multiplierRequired: {
          el: 'Προσθέστε το πολλαπλασιαστή πόντων για αυτό το πακέτο.',
          en: 'Please add the point multiplier for this package.',
          it: 'Si prega di aggiungere il moltiplicatore di punti per questo pacchetto.',
        },
        multiplierNaN: {
          el: 'Mη έγκυρη τιμή',
          en: 'Invalid value',
          it: 'Valore non valido',
        },
        titleRequired: {
          el: 'Προσθέστε έναν τίτλο για αυτό το πακέτο.',
          en: 'Please add a title for this package.',
          it: 'Aggiungi un titolo per questo pacchetto.',
        },
        descriptionRequired: {
          el: 'Προσθέστε μια περιγραφή για αυτό το πακέτο.',
          en: 'Please add a description for this package.',
          it: 'Aggiungi una descrizione per questo pacchetto.',
        },
        expirationDaysRequired: {
          el: 'Προσθέστε ημέρες λήξεως επιπέδου.',
          en: "Please add the tier's expiration days.",
          it: 'Aggiungere i giorni di scadenza del livello.',
        },
        countableDaysRequired: {
          el: 'Προσθέστε έγκυρο θετικό αριθμό ημερών υπολογίσιμων συναλλαγών επιπέδου.',
          en: "Please add a valid positive number for the tier's Countable transactions days.",
          it: 'Aggiungere un numero valido per i giorni di transazioni conteggiabili del livello.',
        },
      },
    };
  },

  computed: {
    tiersValid() {
      // Check all valid arrays
      const allValid =
        this.valid.expiration_days.every(Boolean) &&
        this.valid.valid_days_before.every(Boolean) &&
        this.valid.title.every(Boolean) &&
        this.valid.description.every(Boolean) &&
        this.valid.minimum_amount.every(Boolean);

      // Check all error arrays (no non-empty string allowed)
      const noErrors =
        this.error.expiration_days.every((err) => !err) &&
        this.error.valid_days_before.every((err) => !err) &&
        this.error.title.every((err) => !err) &&
        this.error.description.every((err) => !err) &&
        this.error.minimum_amount.every((err) => !err);

      return allValid && noErrors;
    },
  },

  methods: {
    validateTierForm(i, tierData) {
      this.validateTitle({ i, tierData });
      this.validateDescription({ i, tierData });
      this.validateExpirationDays({ i, tierData });
      this.validateCountableDays({ i, tierData });
      return this.formValid;
    },
    validateMinimumAmount(i, tierData, validateAdjacents = false) {
      this.tierIndex = i || this.tierIndex;
      this.tierData = tierData || this.tierData;
      this.valid.minimum_amount[i] = false;
      this.success.minimum_amount[i] = false;
      this.error.minimum_amount[i] = '';
      this.$set(this.error.minimum_amount, this.tierIndex, '');
      this.$set(this.valid.minimum_amount, this.tierIndex, false);
      this.$set(this.valid.minimum_amount, 0, true);

      if (this.tierIndex <= 0) {
        this.$set(this.valid.minimum_amount, this.tierIndex, true);
        return true;
      } else if (!this.tierData.from) {
        this.$set(
          this.error.minimum_amount,
          this.tierIndex,
          this.errorMessages.minimumAmountRequired[this.lang]
        );
      } else if (Number(this.tierData.from) <= Number(this.tierValues[this.tierIndex - 1].from)) {
        this.$set(
          this.error.minimum_amount,
          this.tierIndex,
          this.errorMessages.minimumAmountExceededFrom[this.lang] +
            ': ' +
            Number(this.tierValues[this.tierIndex - 1].from)
        );
        // this.valid.minimum_amount = true;
      } else if (
        this.tierValues[this.tierIndex + 1] &&
        this.tierData.to &&
        Number(this.tierData.from) >= Number(this.tierValues[this.tierIndex + 1].from)
      ) {
        this.$set(
          this.error.minimum_amount,
          this.tierIndex,
          this.errorMessages.minimumAmountExceededTo[this.lang] +
            ': ' +
            this.tierValues[this.tierIndex + 1].from
        );
        // this.valid.minimum_amount = true;
      } else {
        if (!this.tierValues[this.tierIndex + 1]) {
          this.tierValues[this.tierIndex].to = parseInt(
            this.tierData.from * this.infinityMultiplier
          );
        }

        this.$set(this.error.minimum_amount, this.tierIndex, '');
        this.$set(this.valid.minimum_amount, this.tierIndex, true);
      }

      if (validateAdjacents) {
        if (
          this.tierValues[this.tierIndex - 1] &&
          this.tierIndex > 1 &&
          this.tierValues[this.tierIndex - 1]?.errors?.length
        ) {
          this.validateMinimumAmount(this.tierIndex - 1, this.tierValues[this.tierIndex - 1]);
        }
        if (
          this.tierValues[this.tierIndex + 1] &&
          this.tierValues[this.tierIndex + 1]?.errors?.length
        ) {
          this.validateMinimumAmount(this.tierIndex + 1, this.tierValues[this.tierIndex + 1]);
        }
      }
    },

    validateExpirationDays({ i, tierData } = {}) {
      this.tierIndex = i || this.tierIndex;
      this.tierData = tierData || this.tierData;
      this.$set(this.valid.expiration_days, this.tierIndex, false);
      if (this.tierIndex === 0) {
        this.$set(this.valid.expiration_days, this.tierIndex, true);
        this.$set(this.error.expiration_days, this.tierIndex, '');
        return true;
      }
      if (this.tiers_settings.system === 'expiration_mode' && this.tierData.expiration_days <= 0) {
        this.$set(
          this.error.expiration_days,
          this.tierIndex,
          this.errorMessages.expirationDaysRequired[this.lang]
        );
      } else {
        this.$set(this.error.expiration_days, this.tierIndex, '');
        this.$set(this.valid.expiration_days, this.tierIndex, true);
      }
    },

    validateCountableDays({ i, tierData } = {}) {
      this.tierIndex = i || this.tierIndex;
      this.tierData = tierData || this.tierData;

      try {
        this.valid.valid_days_before[this.tierIndex] =
          this.tiers_settings.system !== 'expiration_mode' || this.tierIndex === 0;

        if (
          (this.tiers_settings.system == 'expiration_mode' &&
            this.tierData.valid_days_before !== null &&
            Number.isNaN(Number(this.tierData.valid_days_before))) ||
          this.tierData.valid_days_before < 0
        ) {
          this.$set(
            this.error.valid_days_before,
            this.tierIndex,
            this.errorMessages.countableDaysRequired[this.lang]
          );
        } else {
          this.$set(this.error.valid_days_before, this.tierIndex, '');
          this.$set(this.valid.valid_days_before, this.tierIndex, true);
        }
      } catch (error) {
        this.$set(
          this.error.valid_days_before,
          this.tierIndex,
          this.errorMessages.countableDaysRequired[this.lang]
        );
        this.$set(this.valid.valid_days_before, this.tierIndex, false);
        this.$set(this.success.valid_days_before, this.tierIndex, false);
      }
    },

    validateTitle({ i, tierData } = {}) {
      this.tierIndex = i || this.tierIndex;
      this.tierData = tierData || this.tierData;

      this.$set(this.valid.title, this.tierIndex, false);
      if (!this.tierData?.title?.en || !this.tierData?.title?.el || !this.tierData?.title?.it) {
        this.$set(this.error.title, this.tierIndex, this.errorMessages.titleRequired[this.lang]);
      } else {
        this.$set(this.error.title, this.tierIndex, '');
        this.$set(this.valid.title, this.tierIndex, true);
      }
    },

    validateDescription({ i, tierData } = {}) {
      this.tierIndex = i || this.tierIndex;
      this.tierData = tierData || this.tierData;
      this.$set(this.valid.description, this.tierIndex, false);
      if (
        !this.tierData?.description?.en ||
        !this.tierData?.description?.el ||
        !this.tierData?.description?.it
      ) {
        this.error.description[this.tierIndex] = this.errorMessages.descriptionRequired[this.lang];
        this.$set(
          this.error.description,
          this.tierIndex,
          this.errorMessages.descriptionRequired[this.lang]
        );
      } else {
        this.$set(this.error.description, this.tierIndex, '');
        this.$set(this.valid.description, this.tierIndex, true);
      }
    },

    resetSuccess() {
      this.success = {
        minimum_amount: [true],
        expiration_days: [true],
        valid_days_before: [true],
        title: [false],
        description: [false],
      };
    },

    resetErrors() {
      this.$set(this, 'error', {
        minimum_amount: [''],
        expiration_days: [''],
        valid_days_before: [''],
        title: [''],
        description: [''],
      });
    },

    resetValidation() {
      this.resetErrors();
      this.valid = {
        minimum_amount: [true],
        expiration_days: [true],
        valid_days_before: [true],
        title: [false],
        description: [false],
      };
    },
  },

  watch: {
    ['tierData.from']: {
      immediate: true,
      handler(val) {
        if (this.tierIndex > 0) {
          this.valid.minimum_amount[this.tierIndex] = !!val;
          this.success.minimum_amount[this.tierIndex] = !!val;
        }
        this.valid.minimum_amount[0] = true;
        this.success.minimum_amount[0] = true;
      },
    },

    ['tierData.expiration_days']: {
      immediate: true,
      handler(val) {
        this.valid.expiration_days[this.tierIndex] =
          val > 0 || this.tiers_settings.system !== 'expiration_mode' || this.tierIndex === 0;
        this.success.expiration_days[this.tierIndex] =
          val > 0 || this.tiers_settings.system !== 'expiration_mode' || this.tierIndex === 0;
      },
    },

    ['tierData.valid_days_before']: {
      immediate: true,
      handler(val) {
        try {
          this.valid.valid_days_before[this.tierIndex] =
            val >= 0 || val === null || this.tiers_settings.system !== 'expiration_mode';
          this.success.valid_days_before[this.tierIndex] =
            val >= 0 || val === null || this.tiers_settings.system !== 'expiration_mode';
        } catch (error) {
          this.valid.valid_days_before[this.tierIndex] = false;
          this.success.valid_days_before[this.tierIndex] = false;
        }
      },
    },

    ['tierData.title']: {
      deep: true,
      handler(val) {
        this.valid.title[this.tierIndex] = !!(val.en || val.el || val.it);
        this.success.title[this.tierIndex] = !!(val.en || val.el || val.it);
      },
    },

    ['tierData.description']: {
      deep: true,
      handler(val) {
        this.valid.description[this.tierIndex] = !!(val.en || val.el || val.it);
        this.success.description[this.tierIndex] = !!(val.en || val.el || val.it);
      },
    },
  },
  created() {
    this.debouncedValidation = debounce(this.validateTierForm, 800);
  },
};
